/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import ReduxUtils from '../../utils/ReduxUtils';
import ProfileModel from './ProfileModel';
import RESOURCE_NAMES from '../../api/resources';

/**
 * Fetches the user profile model data from the server api.
 *
 * @param {function} callback called if request successful.
 */
var fetchUserProfile = function fetchUserProfile(callback) {
  ReduxUtils.getModelDataFromRestAPI(callback, RESOURCE_NAMES.profile, ProfileModel);
};
export default {
  fetchUserProfile: fetchUserProfile
};